var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6161 9.58738L33.3482 6.26506C38.6607 4.23774 44.2634 3.21068 50 3.21068C50.3973 3.21068 50.7991 3.2196 51.1964 3.22853L51.1072 6.78306C50.7411 6.77413 50.3705 6.76967 50 6.76967C44.7009 6.76967 39.5223 7.71635 34.6161 9.58738Z",
    fill: "url(#paint0_diamond_423_49535)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1384 7.07332C60.7589 7.73867 66.1116 9.47574 71.0446 12.2354L72.7812 9.1319C67.4375 6.1445 61.6384 4.26453 55.5536 3.54112L55.1339 7.07332H55.1384Z",
    fill: "url(#paint1_diamond_423_49535)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6205 21.3763L14.9554 19.0185C19.0179 14.4235 23.8571 10.7216 29.3393 8.01553L30.9107 11.2084C25.8482 13.709 21.375 17.1296 17.6205 21.3763Z",
    fill: "url(#paint2_diamond_423_49535)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.875 88.3496C46.4464 88.2736 45.0045 88.1129 43.5982 87.8762H43.6027L43.7187 87.1751C45.0982 87.4073 46.5089 87.5636 47.9152 87.6395L47.875 88.3496Z",
    fill: "url(#paint3_diamond_423_49535)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0268 87.6976V88.4076C52.9062 88.4076 55.7813 88.0816 58.567 87.4475L58.4107 86.7554C55.6786 87.3806 52.8571 87.6931 50.0313 87.6976H50.0268Z",
    fill: "url(#paint4_diamond_423_49535)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6607 86.9117L60.4643 86.2284C61.8125 85.84 63.1518 85.3711 64.4509 84.8308L64.7232 85.4872C63.4018 86.0364 62.0357 86.5142 60.6607 86.9117Z",
    fill: "url(#paint5_diamond_423_49535)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3795 84.6253C35.9643 85.8712 38.6964 86.8224 41.4955 87.4565L41.6518 86.7643C38.9062 86.1436 36.2277 85.2059 33.6875 83.9823L33.3795 84.6253Z",
    fill: "url(#paint6_diamond_423_49535)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4643 83.634C30.2143 82.9419 28.9866 82.1738 27.8214 81.3432L28.2321 80.7627C29.375 81.5754 30.5804 82.3346 31.808 83.0133L31.4643 83.634Z",
    fill: "url(#paint7_diamond_423_49535)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.375 83.9689L66.683 84.6075C69.2634 83.3616 71.7098 81.821 73.9509 80.0259L73.5089 79.4677C71.308 81.2271 68.9062 82.7409 66.375 83.9645V83.9689Z",
    fill: "url(#paint8_diamond_423_49535)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5938 78.6371L75.1205 78.1057C76.1652 77.1724 77.1696 76.1677 78.1071 75.1183L78.6384 75.5917C77.683 76.6589 76.6607 77.686 75.5938 78.6371Z",
    fill: "url(#paint9_diamond_423_49535)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0179 73.9707C21.808 76.2124 23.8571 78.2576 26.0982 80.0438L26.5402 79.4856C24.3393 77.7306 22.3303 75.7256 20.5714 73.5242L20.0179 73.9707Z",
    fill: "url(#paint10_diamond_423_49535)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7187 72.247C17.8884 71.0815 17.1161 69.858 16.4241 68.6077L17.0446 68.2638C17.7277 69.4874 18.4866 70.6931 19.2991 71.8362L18.7187 72.247Z",
    fill: "url(#paint11_diamond_423_49535)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4688 73.4929L80.0268 73.935C81.8214 71.6888 83.3616 69.2373 84.6071 66.6607L83.9688 66.3526C82.7455 68.8845 81.2366 71.287 79.4732 73.4929H79.4688Z",
    fill: "url(#paint12_diamond_423_49535)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4866 64.6914L84.8303 64.419C85.3661 63.1241 85.8348 61.7799 86.2232 60.4314L86.9062 60.6278C86.5134 62.0032 86.0357 63.3697 85.4866 64.6914Z",
    fill: "url(#paint13_diamond_423_49535)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5893 58.5826C13.2277 61.378 14.1875 64.1065 15.4375 66.692L16.0759 66.3839C14.8482 63.8475 13.9107 61.1682 13.2812 58.4219L12.5893 58.5826Z",
    fill: "url(#paint14_diamond_423_49535)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1696 56.4705C11.9286 55.0639 11.7678 53.626 11.6875 52.1925L12.3973 52.1524C12.4777 53.559 12.6384 54.9701 12.8705 56.3499L12.1696 56.4705Z",
    fill: "url(#paint15_diamond_423_49535)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.683 49.9107V49.9955C87.683 52.8266 87.3705 55.6444 86.7455 58.3817L87.4375 58.538C88.0714 55.7515 88.3929 52.8802 88.3929 49.9955V49.9107H87.683Z",
    fill: "url(#paint16_diamond_423_49535)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.625 47.7985C87.5447 46.3919 87.3839 44.9808 87.1473 43.601L87.8482 43.4804C88.0893 44.887 88.2545 46.3249 88.3348 47.7583L87.625 47.7985Z",
    fill: "url(#paint17_diamond_423_49535)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 49.9955V50.0402H12.3348V49.9955C12.3348 47.1823 12.6473 44.3735 13.2634 41.654L12.5714 41.4977C11.9464 44.2708 11.6295 47.1287 11.6295 49.9955H11.625Z",
    fill: "url(#paint18_diamond_423_49535)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7902 39.6088L13.1071 39.4123C13.5 38.037 13.9777 36.6661 14.5223 35.3443L15.1786 35.6167C14.6429 36.9161 14.1741 38.2602 13.7902 39.6088Z",
    fill: "url(#paint19_diamond_423_49535)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.933 33.5715C85.1607 36.1079 86.1072 38.7827 86.7366 41.529L87.4286 41.3682C86.7857 38.5728 85.8259 35.8444 84.5714 33.2589L83.933 33.5715Z",
    fill: "url(#paint20_diamond_423_49535)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9598 31.7005C82.2812 30.4769 81.5223 29.2757 80.7054 28.1325H80.7009L81.2812 27.7172C82.1116 28.8827 82.8884 30.1107 83.5804 31.3566L82.9598 31.7005Z",
    fill: "url(#paint21_diamond_423_49535)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4063 33.3795L15.408 33.3803L15.4063 33.3839V33.3795Z",
    fill: "url(#paint22_diamond_423_49535)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0491 33.6876L15.408 33.3803C16.6532 30.7961 18.1883 28.3503 19.9777 26.1007L20.5357 26.5428C18.7768 28.7488 17.2679 31.1557 16.0491 33.6876Z",
    fill: "url(#paint23_diamond_423_49535)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3661 24.453L21.8973 24.9263C22.8303 23.8769 23.8348 22.8722 24.8795 21.9344L24.4062 21.4031C23.3437 22.3587 22.317 23.3813 21.3661 24.4485V24.453Z",
    fill: "url(#paint24_diamond_423_49535)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4375 26.4446C77.6741 24.2476 75.6652 22.2426 73.4598 20.4876V20.4832L73.9018 19.9294C76.1473 21.7201 78.1964 23.7608 79.9911 25.998L79.4375 26.4446Z",
    fill: "url(#paint25_diamond_423_49535)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.183 16.9688L68.1849 16.9699L68.183 16.9733V16.9688Z",
    fill: "url(#paint26_diamond_423_49535)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1849 16.9699C69.4164 17.6483 70.6167 18.4027 71.7634 19.215L72.1741 18.6344C71.0045 17.8083 69.7812 17.0358 68.5268 16.3481L68.1849 16.9699Z",
    fill: "url(#paint27_diamond_423_49535)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4911 20.5546L26.0495 20.0014C28.2893 18.2035 30.734 16.6643 33.308 15.4148L33.6205 16.0534C31.0893 17.2769 28.692 18.7907 26.4911 20.5546Z",
    fill: "url(#paint28_diamond_423_49535)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6563 84.085H50.3661V81.2494H49.6563V84.085Z",
    fill: "url(#paint29_diamond_423_49535)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.317 83.8885L46.5937 81.0708L47.3036 81.1378L47.0268 83.96L46.317 83.8885Z",
    fill: "url(#paint30_diamond_423_49535)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9955 83.9555L52.7187 81.1333L52.7232 81.1289L53.4286 81.0619L53.7054 83.8841L52.9955 83.9555Z",
    fill: "url(#paint31_diamond_423_49535)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0179 83.3661L43.7143 83.5045L44.2679 80.7225L43.5714 80.5841L43.0179 83.3661Z",
    fill: "url(#paint32_diamond_423_49535)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3125 83.5045L55.7589 80.7225L56.4554 80.5841L57.0089 83.3661L56.3125 83.5045Z",
    fill: "url(#paint33_diamond_423_49535)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7857 82.5221L40.4643 82.7275L41.2902 80.0125L40.6116 79.8071L39.7902 82.5221H39.7857Z",
    fill: "url(#paint34_diamond_423_49535)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5625 82.7275L58.7411 80.0125L59.4196 79.8071L60.2455 82.5221L59.5625 82.7275Z",
    fill: "url(#paint35_diamond_423_49535)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6473 81.3611L37.3036 81.6335L38.3884 79.0122L37.7321 78.7398L36.6473 81.3611Z",
    fill: "url(#paint36_diamond_423_49535)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7232 81.6335L61.6384 79.0122L62.2946 78.7398L63.3795 81.3611L62.7232 81.6335Z",
    fill: "url(#paint37_diamond_423_49535)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6384 79.8964L34.2634 80.2313L35.5982 77.7306L34.9732 77.3957L33.6384 79.8964Z",
    fill: "url(#paint38_diamond_423_49535)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7589 80.2313L64.4196 77.7306L65.0491 77.3957L66.3839 79.8964L65.7589 80.2313Z",
    fill: "url(#paint39_diamond_423_49535)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7902 78.1459L31.3795 78.5434L32.9554 76.1856L32.3616 75.7882L30.7857 78.1459H30.7902Z",
    fill: "url(#paint40_diamond_423_49535)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6429 78.5389L67.067 76.1811H67.0714L67.6607 75.7837L69.2366 78.1415L68.6429 78.5389Z",
    fill: "url(#paint41_diamond_423_49535)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 76.1231L28.6741 76.5741L30.4732 74.3815L29.9241 73.9305L28.125 76.1231Z",
    fill: "url(#paint42_diamond_423_49535)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3482 76.5741L69.5491 74.3815L70.0982 73.9305L71.8973 76.1231L71.3482 76.5741Z",
    fill: "url(#paint43_diamond_423_49535)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6741 73.8501L26.1786 74.3547L28.183 72.3497L27.6786 71.8451L25.6741 73.8501Z",
    fill: "url(#paint44_diamond_423_49535)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8482 74.3547L71.8438 72.3497L72.3482 71.8451L74.3527 73.8501L73.8482 74.3547Z",
    fill: "url(#paint45_diamond_423_49535)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4509 71.345L23.9018 71.8943L26.0938 70.0947L25.6429 69.5454L23.4509 71.345Z",
    fill: "url(#paint46_diamond_423_49535)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1161 71.8943L73.9241 70.0947L74.375 69.5454L76.567 71.345L76.1161 71.8943Z",
    fill: "url(#paint47_diamond_423_49535)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4866 68.6389L21.8795 69.2284L24.2366 67.6521L23.8393 67.0626L21.4821 68.6389H21.4866Z",
    fill: "url(#paint48_diamond_423_49535)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1384 69.2284L75.7812 67.6521H75.7857L76.1786 67.0626L78.5357 68.6389L78.1384 69.2284Z",
    fill: "url(#paint49_diamond_423_49535)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7991 65.7498L19.801 65.7532L19.7991 65.7542V65.7498Z",
    fill: "url(#paint50_diamond_423_49535)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.801 65.7532L20.1339 66.3794L22.6339 65.0442L22.2991 64.419L19.801 65.7532Z",
    fill: "url(#paint51_diamond_423_49535)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3884 65.0397L79.8884 66.3749L80.2232 65.7453L77.7232 64.4101L77.3884 65.0353V65.0397Z",
    fill: "url(#paint52_diamond_423_49535)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6696 63.3696L18.3973 62.7132L21.0179 61.6281L21.2902 62.2845L18.6696 63.3696Z",
    fill: "url(#paint53_diamond_423_49535)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7321 62.2845L81.3527 63.3696L81.625 62.7132L79.0045 61.6281L78.7321 62.2845Z",
    fill: "url(#paint54_diamond_423_49535)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5089 60.2304L17.3036 59.5517L20.0179 58.73L20.2232 59.4088L17.5089 60.2304Z",
    fill: "url(#paint55_diamond_423_49535)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7991 59.4088L82.5134 60.2304L82.7188 59.5517L80.0045 58.73L79.7991 59.4088Z",
    fill: "url(#paint56_diamond_423_49535)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6652 56.9929L16.5268 56.2963L19.308 55.7426L19.4464 56.4392L16.6652 56.9929Z",
    fill: "url(#paint57_diamond_423_49535)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5714 56.4392L83.3527 56.9929L83.4911 56.2963L80.7098 55.7426L80.5714 56.4392Z",
    fill: "url(#paint58_diamond_423_49535)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1429 53.6885L16.0714 52.9829L18.8929 52.7061L18.9643 53.4116L16.1429 53.6885Z",
    fill: "url(#paint59_diamond_423_49535)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0536 53.4116L83.875 53.6885L83.9464 52.9829L81.125 52.7061L81.0536 53.4116Z",
    fill: "url(#paint60_diamond_423_49535)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7813 50.3528H15.9464V49.6428H18.7813V50.3528Z",
    fill: "url(#paint61_diamond_423_49535)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2411 50.3528H84.0759V49.6428H81.2411V50.3528Z",
    fill: "url(#paint62_diamond_423_49535)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0759 47.0126L16.1473 46.307L18.9687 46.5839L18.8973 47.2895L16.0759 47.0126Z",
    fill: "url(#paint63_diamond_423_49535)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1295 47.2895L81.0581 46.5839V46.5794L83.8795 46.3026L83.9509 47.0126L81.1295 47.2895Z",
    fill: "url(#paint64_diamond_423_49535)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 43.6947L19.3125 44.2485L19.4509 43.5518L16.6696 42.9981L16.5312 43.6947Z",
    fill: "url(#paint65_diamond_423_49535)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7143 44.2485L80.5759 43.5518L83.3572 42.9981L83.4955 43.6947L80.7143 44.2485Z",
    fill: "url(#paint66_diamond_423_49535)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.308 40.4439L20.0223 41.27L20.2277 40.5912L17.5134 39.7651L17.308 40.4439Z",
    fill: "url(#paint67_diamond_423_49535)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0089 41.2655L79.8036 40.5868L82.5179 39.7606L82.7232 40.4394L80.0089 41.2655Z",
    fill: "url(#paint68_diamond_423_49535)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4018 37.2823L21.0223 38.3674L21.2946 37.711L18.6741 36.6259L18.4018 37.2823Z",
    fill: "url(#paint69_diamond_423_49535)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0089 38.3674L78.7366 37.711L81.3571 36.6259L81.6295 37.2823L79.0089 38.3674Z",
    fill: "url(#paint70_diamond_423_49535)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7991 34.2458L19.801 34.2468L19.7991 34.2502V34.2458Z",
    fill: "url(#paint71_diamond_423_49535)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19.801 34.2468L22.2991 35.5854L22.6339 34.9603L20.1339 33.6251L19.801 34.2468Z",
    fill: "url(#paint72_diamond_423_49535)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3929 34.9558L77.7277 35.581L80.2277 34.2413L79.8929 33.6161L77.3929 34.9513V34.9558Z",
    fill: "url(#paint73_diamond_423_49535)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8482 32.9374L21.4911 31.3611H21.4955L21.8884 30.7716L24.2455 32.3479L23.8482 32.9374Z",
    fill: "url(#paint74_diamond_423_49535)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7857 32.3479L76.1786 32.9374L78.5357 31.3611L78.1384 30.7716L75.7812 32.3479H75.7857Z",
    fill: "url(#paint75_diamond_423_49535)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6518 30.459L23.4598 28.6595L23.9107 28.1102L26.1027 29.9098L25.6518 30.459Z",
    fill: "url(#paint76_diamond_423_49535)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M73.933 29.9098L74.3839 30.459L76.5759 28.6595L76.125 28.1102L73.933 29.9098Z",
    fill: "url(#paint77_diamond_423_49535)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.683 28.1683L25.6786 26.1633L26.183 25.6587L28.1875 27.6637L27.683 28.1683Z",
    fill: "url(#paint78_diamond_423_49535)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8482 27.6681L72.3527 28.1727L74.3571 26.1677L73.8527 25.6631L71.8482 27.6681Z",
    fill: "url(#paint79_diamond_423_49535)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M29.933 26.0873L28.1339 23.8948L28.683 23.4438L30.4821 25.6363L29.933 26.0873Z",
    fill: "url(#paint80_diamond_423_49535)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.558 25.6363L70.1071 26.0873L71.9062 23.8948L71.3571 23.4438L69.558 25.6363Z",
    fill: "url(#paint81_diamond_423_49535)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 24.2252L30.7991 21.8675H30.8036L31.3929 21.47L32.9688 23.8278L32.375 24.2252Z",
    fill: "url(#paint82_diamond_423_49535)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0759 23.8323L67.6652 24.2297L69.2411 21.8719L68.6473 21.4745L67.0714 23.8323H67.0759Z",
    fill: "url(#paint83_diamond_423_49535)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0179 75.6051C35.9107 75.6051 24.433 64.1199 24.433 50.0089C24.433 35.898 35.9063 24.4173 50.0179 24.4173C64.1295 24.4173 75.6071 35.8935 75.6071 50.0089C75.6071 64.1243 64.125 75.6051 50.0179 75.6051ZM50.0153 36.2431L55.3887 45.0552L50.0153 48.1907L44.642 45.0552L50.0153 36.2431ZM58.8099 47.6681C60.9775 47.335 63.0015 46.538 64.8297 45.2969L64.8101 45.2773L70.1834 41.6322L67.7873 47.7857C65.8482 52.7568 62.0091 56.7154 57.2103 58.7143C55.4932 60.9222 53.3125 62.7382 50.8706 64.0055L49.9696 64.4758L49.0686 64.0055C46.5941 62.7186 44.3939 60.8634 42.6637 58.6229C37.8126 56.526 33.9932 52.4433 32.1389 47.348L29.8211 40.966L35.1945 44.9311C36.9965 46.2571 39.014 47.1455 41.1946 47.5636C42.1022 47.74 43.0293 47.8249 43.963 47.8249C44.1523 47.8249 44.3351 47.8249 44.5244 47.8184L46.9141 51.7443C45.9347 51.9011 44.9554 51.9795 43.9564 51.9795C42.7812 51.9795 41.606 51.8749 40.4569 51.6528C40.0717 51.581 39.693 51.4961 39.3143 51.3981C40.8029 52.9528 42.6115 54.1809 44.6354 54.9778L45.1773 55.1934L45.5234 55.6768C46.7313 57.336 48.2525 58.747 49.9696 59.7987C51.6737 58.7666 53.1754 57.3817 54.3637 55.7551L54.7227 55.2718L55.2777 55.0627C57.3082 54.2919 59.1364 53.0769 60.6511 51.5418C60.2398 51.6333 59.8284 51.7116 59.4041 51.777C58.4769 51.9272 57.5172 51.9991 56.5509 51.9991C55.3952 51.9991 54.2657 51.8946 53.1493 51.6855L55.5128 47.8118C55.8588 47.8314 56.2048 47.8445 56.5509 47.8445C57.3082 47.8445 58.0721 47.7857 58.8099 47.6681ZM50.0153 53.5407L55.3952 46.0546L50.0153 49.1967L44.642 46.0546L50.0153 53.5407Z",
    fill: "url(#paint84_diamond_423_49535)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1696 50.0045C22.1696 65.3925 34.6384 77.8646 50.0223 77.8646C65.4062 77.8646 77.875 65.3925 77.875 50.0045C77.875 34.6164 65.4062 22.1443 50.0223 22.1443C34.6384 22.1443 22.1696 34.6164 22.1696 50.0045ZM23.7232 50.0045C23.7232 35.5006 35.5223 23.6983 50.0223 23.6983C64.5223 23.6983 76.3214 35.5006 76.3214 50.0045C76.3214 64.5083 64.5223 76.3106 50.0223 76.3106C35.5223 76.3106 23.7232 64.5083 23.7232 50.0045Z",
    fill: "url(#paint85_diamond_423_49535)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0223 79.9277C33.5223 79.9277 20.0982 66.5 20.0982 49.9955C20.0982 33.4911 33.5223 20.0634 50.0223 20.0634C66.5223 20.0634 79.9464 33.4911 79.9464 49.9955C79.9464 66.5 66.5223 79.9277 50.0223 79.9277ZM50.0223 20.7734C33.9152 20.7734 20.808 33.8841 20.808 49.9955C20.808 66.107 33.9107 79.2177 50.0223 79.2177C66.1339 79.2177 79.2366 66.1115 79.2366 49.9955C79.2366 33.8796 66.1295 20.7734 50.0223 20.7734Z",
    fill: "url(#paint86_diamond_423_49535)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6518 20.1081L34.9866 22.6087L35.6116 22.2738L34.2768 19.7731L33.6518 20.1081Z",
    fill: "url(#paint87_diamond_423_49535)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0625 22.6087L64.433 22.2738L65.7723 19.7731L66.3973 20.1081L65.0625 22.6087Z",
    fill: "url(#paint88_diamond_423_49535)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6562 18.6434L37.7411 21.2646L38.3973 20.9922L37.3125 18.371L36.6562 18.6434Z",
    fill: "url(#paint89_diamond_423_49535)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3036 21.2646L61.6473 20.9922L62.7321 18.371L63.3884 18.6434L62.3036 21.2646Z",
    fill: "url(#paint90_diamond_423_49535)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7902 17.4824L40.6116 20.1974L41.2902 19.992L40.4643 17.2769L39.7857 17.4824H39.7902Z",
    fill: "url(#paint91_diamond_423_49535)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4241 20.1974L58.7455 19.992L59.567 17.2769L60.25 17.4824L59.4241 20.1974Z",
    fill: "url(#paint92_diamond_423_49535)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0223 16.6384L43.5759 19.4204L44.2723 19.2819L43.7187 16.4999L43.0223 16.6384Z",
    fill: "url(#paint93_diamond_423_49535)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4598 19.4204L55.7634 19.2819L56.317 16.4999L57.0134 16.6384L56.4598 19.4204Z",
    fill: "url(#paint94_diamond_423_49535)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3259 16.1159L46.6027 18.9381L47.3125 18.8667L47.0357 16.0445L46.3259 16.1115V16.1159Z",
    fill: "url(#paint95_diamond_423_49535)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M53.433 18.9426L52.7277 18.8711L52.7232 18.8756L53 16.0534L53.7098 16.1204L53.433 18.9426Z",
    fill: "url(#paint96_diamond_423_49535)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6652 18.755H50.375V15.9194H49.6652V18.755Z",
    fill: "url(#paint97_diamond_423_49535)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0134 86.4026C29.9464 86.4026 13.6161 70.0723 13.6161 49.9955C13.6161 29.9232 29.9464 13.5885 50.0134 13.5885C70.0804 13.5885 86.4107 29.9187 86.4107 49.9955C86.4107 70.0723 70.0804 86.4026 50.0134 86.4026ZM50.0179 15.0085C30.7321 15.0085 15.0402 30.7047 15.0402 49.9955C15.0402 69.2864 30.7277 84.9826 50.0179 84.9826C69.308 84.9826 84.9955 69.2909 84.9955 49.9955C84.9955 30.7002 69.3036 15.0085 50.0179 15.0085Z",
    fill: "url(#paint98_diamond_423_49535)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2634 14.5351L35.5357 15.1916C36.8304 14.6512 38.1696 14.1779 39.5179 13.7894L39.3214 13.1062C37.9464 13.5036 36.5804 13.9859 35.2589 14.5351H35.2634Z",
    fill: "url(#paint99_diamond_423_49535)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2946 16.0043C63.7545 14.7807 61.0714 13.8519 58.3259 13.2312L58.4821 12.5346C61.2812 13.1687 64.0134 14.1154 66.6027 15.3612L66.2946 16.0043Z",
    fill: "url(#paint100_diamond_423_49535)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0536 12.3649C53.4598 12.4408 54.8705 12.5971 56.25 12.8249L56.3661 12.1238C54.9598 11.8871 53.5179 11.7308 52.0893 11.6549L52.0491 12.3649H52.0536Z",
    fill: "url(#paint101_diamond_423_49535)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M41.558 13.258L41.4018 12.5659H41.3973C44.183 11.9273 47.0536 11.6013 49.9375 11.5969V12.3069C47.1116 12.3113 44.2902 12.6328 41.558 13.258Z",
    fill: "url(#paint102_diamond_423_49535)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64732 49.9911C8.64732 72.8008 27.1964 91.3548 50 91.3548C72.8036 91.3548 91.3527 72.8008 91.3527 49.9911C91.3527 27.1814 72.8036 8.62731 50 8.62731C27.1964 8.62731 8.64732 27.1814 8.64732 49.9911ZM10.0714 49.9911C10.0714 27.9673 27.9821 10.0518 50 10.0518C72.0179 10.0518 89.9286 27.9673 89.9286 49.9911C89.9286 72.0148 72.0179 89.9303 50 89.9303C27.9821 89.9303 10.0714 72.0148 10.0714 49.9911Z",
    fill: "url(#paint103_diamond_423_49535)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4828 14.3779C79.1413 17.588 83.0726 21.6147 86.1741 26.3508L89.1518 24.4039C85.7991 19.2819 81.5402 14.9236 76.5 11.4495L74.4828 14.3779Z",
    fill: "url(#paint104_diamond_423_49535)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4828 14.3779L74.4821 14.3788L74.4777 14.3744L74.4828 14.3779Z",
    fill: "url(#paint105_diamond_423_49535)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 38.8675L8.0491 39.7115C9.38839 34.2279 11.7634 29.1239 15.1071 24.5423L12.2366 22.4435C8.61607 27.4002 6.04464 32.924 4.59375 38.8631V38.8675Z",
    fill: "url(#paint106_diamond_423_49535)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0268 45.8694C92.4911 40.2295 90.8839 34.8352 88.2411 29.8383L91.3839 28.1772C94.2456 33.5894 95.9866 39.4302 96.567 45.5345L93.0268 45.8694Z",
    fill: "url(#paint107_diamond_423_49535)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25446 49.9955C3.25446 53.7957 3.70981 57.5779 4.6116 61.2351L8.06696 60.3822C7.23214 57.0063 6.8125 53.5099 6.8125 49.9955C6.8125 47.8744 6.96875 45.7444 7.27232 43.6635L3.75446 43.1455C3.4241 45.3961 3.25446 47.7003 3.25446 49.9955Z",
    fill: "url(#paint108_diamond_423_49535)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2143 49.9955V49.8973H96.7723V49.9866C96.7723 56.149 95.5938 62.1282 93.2768 67.7682L89.9866 66.4151C92.1295 61.2039 93.2143 55.6801 93.2143 49.9955Z",
    fill: "url(#paint109_diamond_423_49535)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85852 65.4367C7.87195 71.2045 10.9608 76.4546 15.0357 81.0485L17.6964 78.6863C13.9286 74.444 11.0759 69.5901 9.21428 64.2627L5.85852 65.4367Z",
    fill: "url(#paint110_diamond_423_49535)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85852 65.4367L5.85714 65.4372V65.4327L5.85852 65.4367Z",
    fill: "url(#paint111_diamond_423_49535)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7768 83.1205L80.0625 85.8444C84.7589 81.9014 88.5803 77.1546 91.4241 71.7424L88.2768 70.0857C85.6473 75.0871 82.1161 79.4722 77.7723 83.116L77.7768 83.1205Z",
    fill: "url(#paint112_diamond_423_49535)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4598 93.7707C27.7465 91.6053 22.5731 88.3819 18.0915 84.1898L20.5179 81.5933C24.6652 85.4649 29.442 88.4433 34.7187 90.4439L33.4598 93.7707Z",
    fill: "url(#paint113_diamond_423_49535)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0915 84.1898L18.0893 84.1877V84.1922L18.0915 84.1898Z",
    fill: "url(#paint114_diamond_423_49535)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9777 95.7221L59.2232 92.2435H59.2277C64.7455 91.0467 69.9063 88.8006 74.567 85.5765L76.5893 88.5014C71.5402 91.9934 65.9554 94.4226 59.9777 95.7221Z",
    fill: "url(#paint115_diamond_423_49535)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M50 96.7849C45.7946 96.7849 41.625 96.2267 37.6027 95.1237V95.1192L38.5446 91.6897C42.2545 92.7079 46.1116 93.2259 50 93.2259C51.75 93.2259 53.5089 93.1187 55.2321 92.9133L55.6562 96.4455C53.7946 96.6732 51.8884 96.7849 50 96.7849Z",
    fill: "url(#paint116_diamond_423_49535)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 49.9659C0.0109752 22.9483 21.547 0.872681 48.3516 0H51.6485C78.4599 0.872903 100 22.9595 100 49.9866C100 77.5654 77.5714 100 50 100C22.4355 100 0.0111993 77.5766 0 50.0073V49.9659ZM1.4241 49.9866C1.4241 23.1937 23.2143 1.39769 50 1.39769C76.7857 1.39769 98.5759 23.1937 98.5759 49.9866C98.5759 76.7795 76.7857 98.5755 50 98.5755C23.2143 98.5755 1.4241 76.7795 1.4241 49.9866Z",
    fill: "url(#paint117_diamond_423_49535)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_diamond_423_49535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0045 49.5133) rotate(0.557788) scale(49.9979 50.0113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3390A4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.3a5ea50898ee38cd06339af0ab3d28d2.svg";
export { ForwardRef as ReactComponent };